import {updatePartnerCompanyPlan} from "../Util/queries";
import {getAccountsDetails} from "./partnerAccountsAction";

export const updatePartnerPlan = (companyId, adminId, subsType) => async dispatch => {
    try {
        let data = {
            companyId: companyId,
            adminId: adminId,
            subscriptionType: subsType
        }
        console.log(data);
        await updatePartnerCompanyPlan(data);        
    } catch (e) {
        console.error(e);
    } finally {
        dispatch(getAccountsDetails());
    }
}
